var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.showType === 'new')?[_c('new-version')]:[_c('old-version')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }